import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { mergeUrlQueryParams } from '@sparefoot/react-core/utils/url';

import { Image } from 'components/core/Image';

import './TrackingPixel.scss';

export function TrackingPixel({ src }) {
	const trackingURL = useSelector((state) => state.app.trackingURL);
	const trackingId = useSelector((state) => state.app.trackingId);

	return (
		<Image
			src={`${trackingURL}${mergeUrlQueryParams(src, { a: trackingId })}`}
			className="tracking-pixel"
			alt="tracking pixel"
		/>
	);
}

TrackingPixel.propTypes = {
	src: PropTypes.string.isRequired,
};

export default TrackingPixel;
